import { c as _c } from "react/compiler-runtime";
import BookingDetailCancellation from './components/BookingDetailCancellation';
import BookingDetailFiltersSummary from './components/BookingDetailFiltersSummary';
import BookingDetailHeader from './components/BookingDetailHeader';
import BookingDetailPrice from './components/BookingDetailPrice';
const BookingDetailContent = (t0) => {
    const $ = _c(45);
    let addToCartButton;
    let calculatedPrice;
    let cancellationAmount;
    let completion;
    let entity;
    let filters;
    let loading;
    let onCancel;
    let onOpenBookingDetailModal;
    let props;
    let showCancellation;
    let t1;
    if ($[0] !== t0) {
        ({ addToCartButton, calculatedPrice, completion, contentClassName: t1, entity, filters, onOpenBookingDetailModal, cancellationAmount, onCancel, loading, showCancellation, ...props } = t0);
        $[0] = t0;
        $[1] = addToCartButton;
        $[2] = calculatedPrice;
        $[3] = cancellationAmount;
        $[4] = completion;
        $[5] = entity;
        $[6] = filters;
        $[7] = loading;
        $[8] = onCancel;
        $[9] = onOpenBookingDetailModal;
        $[10] = props;
        $[11] = showCancellation;
        $[12] = t1;
    }
    else {
        addToCartButton = $[1];
        calculatedPrice = $[2];
        cancellationAmount = $[3];
        completion = $[4];
        entity = $[5];
        filters = $[6];
        loading = $[7];
        onCancel = $[8];
        onOpenBookingDetailModal = $[9];
        props = $[10];
        showCancellation = $[11];
        t1 = $[12];
    }
    const contentClassName = t1 === undefined ? "" : t1;
    const modal = "modal" in props && props.modal;
    const cancellation = entity.cancellation;
    const computedContentClassName = `flex-auto flex flex-col overflow-auto font-semibold px-6 ${contentClassName}`;
    const cancellationClassName = `last:pb-4-safe ${contentClassName}`;
    let t2;
    if ($[13] !== contentClassName || $[14] !== entity) {
        t2 = <BookingDetailHeader entity={entity} contentClassName={contentClassName}/>;
        $[13] = contentClassName;
        $[14] = entity;
        $[15] = t2;
    }
    else {
        t2 = $[15];
    }
    let t3;
    if ($[16] !== completion || $[17] !== filters) {
        t3 = <BookingDetailFiltersSummary filters={filters} completion={completion}/>;
        $[16] = completion;
        $[17] = filters;
        $[18] = t3;
    }
    else {
        t3 = $[18];
    }
    let t4;
    if ($[19] !== calculatedPrice || $[20] !== cancellation || $[21] !== entity || $[22] !== modal || $[23] !== onOpenBookingDetailModal) {
        t4 = <BookingDetailPrice entity={entity} calculatedPrice={calculatedPrice} cancellation={cancellation} modal={modal} onOpenBookingDetailModal={onOpenBookingDetailModal}/>;
        $[19] = calculatedPrice;
        $[20] = cancellation;
        $[21] = entity;
        $[22] = modal;
        $[23] = onOpenBookingDetailModal;
        $[24] = t4;
    }
    else {
        t4 = $[24];
    }
    let t5;
    if ($[25] !== computedContentClassName || $[26] !== t3 || $[27] !== t4) {
        t5 = <div className={computedContentClassName}>{t3}{t4}
    </div>;
        $[25] = computedContentClassName;
        $[26] = t3;
        $[27] = t4;
        $[28] = t5;
    }
    else {
        t5 = $[28];
    }
    let t6;
    if ($[29] !== calculatedPrice || $[30] !== cancellation || $[31] !== cancellationAmount || $[32] !== cancellationClassName || $[33] !== completion || $[34] !== filters || $[35] !== loading || $[36] !== modal || $[37] !== onCancel || $[38] !== showCancellation) {
        t6 = (modal || showCancellation) && "time" in filters &&
            <BookingDetailCancellation cancellation={cancellation} filters={filters} completion={completion} calculatedPrice={calculatedPrice} cancellationAmount={cancellationAmount} className={cancellationClassName} onCancel={onCancel} loading={loading}/>;
        $[29] = calculatedPrice;
        $[30] = cancellation;
        $[31] = cancellationAmount;
        $[32] = cancellationClassName;
        $[33] = completion;
        $[34] = filters;
        $[35] = loading;
        $[36] = modal;
        $[37] = onCancel;
        $[38] = showCancellation;
        $[39] = t6;
    }
    else {
        t6 = $[39];
    }
    let t7;
    if ($[40] !== addToCartButton || $[41] !== t2 || $[42] !== t5 || $[43] !== t6) {
        t7 = <>{t2}{t5}{addToCartButton}{t6}</>;
        $[40] = addToCartButton;
        $[41] = t2;
        $[42] = t5;
        $[43] = t6;
        $[44] = t7;
    }
    else {
        t7 = $[44];
    }
    return t7;
};
export default BookingDetailContent;
